module.exports = __webpack_public_path__ + "static/media/icons_Bilan MDT - Mckenzie numérique.dd8c4c84.svg";